import api from "../index";
import urls from "./urls";
import baseUrl from "../baseUrl";
// const header = {}

export default {
  matches({ params, header, errorFn, loadingText }) {
    // return出去了一个promise
    return api.get({
      url: urls.matches,
      params,
      header,
      errorFn,
      loadingText
    });
  },
  formatUrl(url) {
    console.log("format url", baseUrl.getUrl());
    if (process.env.VUE_APP_BASIC_API === "dev") {
      return url;
    } else {
      return baseUrl.getUrl() + url;
    }
  }
};
